import React from 'react'
import Testimonal from './Testimonal'

const Blog = () => {

  return (
    <div style={{marginTop:"20px"}}>
  <div>
  <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
    <div className="container py-5">
      <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: 600}}>
        <h5 className="fw-bold text-primary text-uppercase">Latest Blog</h5>
        <h1 className="mb-0">Read The Latest Articles from Our Blog Post</h1>
      </div>
      <div className="row g-5">
      <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s"
      >
          <div className="blog-item bg-light rounded overflow-hidden">
            <div className="blog-img position-relative overflow-hidden">
              <img className="img-fluid" src="assets/img/blog-1.jpg" alt />
              <a className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4" href>Web Design</a>
            </div>
            <div className="p-4">
              <div className="d-flex mb-3">
                <small className="me-3"><i className="far fa-user text-primary me-2" />Syed Hakkim</small>
                <small><i className="far fa-calendar-alt text-primary me-2" />01 Jan, 2021</small>
              </div>
              <h4 className="mb-3">How to design Website</h4>
              <p>Choose a website building platform — In order to build a website, you first got to decide what platform you're going to build your website with.</p>
              <a className="text-uppercase" href>Read More <i className="bi bi-arrow-right" /></a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
          <div className="blog-item bg-light rounded overflow-hidden">
            <div className="blog-img position-relative overflow-hidden">
              <img className="img-fluid" src="assets/img/blog-2.jpg" alt />
              <a className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4" href>Web Design</a>
            </div>
            <div className="p-4">
              <div className="d-flex mb-3">
                <small className="me-3"><i className="far fa-user text-primary me-2" />Syed Hakkim</small>
                <small><i className="far fa-calendar-alt text-primary me-2" />01 Jan, 2021</small>
              </div>
              <h4 className="mb-3">Join Queries in Mysql</h4>
              <p>A JOIN clause is used to combine rows from two or more tables, based on a related column between them. ... Notice that the "CustomerID" column in the "Orders" ..</p>
              <a className="text-uppercase" href>Read More <i className="bi bi-arrow-right" /></a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 wow slideInUp" data-wow-delay="0.9s">
          <div className="blog-item bg-light rounded overflow-hidden">
            <div className="blog-img position-relative overflow-hidden">
              <img className="img-fluid" src="assets/img/blog-3.jpg" alt />
              <a className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4" href>Web Design</a>
            </div>
            <div className="p-4">
              <div className="d-flex mb-3">
                <small className="me-3"><i className="far fa-user text-primary me-2" />James</small>
                <small><i className="far fa-calendar-alt text-primary me-2" />01 Jan, 2022</small>
              </div>
              <h4 className="mb-3">How to Speed up Your Laptop</h4>
              <p>Here are 5 quick and simple tips to follow when your laptop is starting to feel sluggish. · Quit foreground, background programs that are not in</p>
              <a className="text-uppercase" href>Read More <i className="bi bi-arrow-right" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Blog Start */}
<Testimonal/>
  {/* Vendor Start */}
  <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
    <div className="container py-5 mb-5">
      <div className="bg-white">
        <div className='scroll_design'> 
          <img src="assets/img/vendor-1.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-2.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-3.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-4.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-5.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-6.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-7.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-8.jpg" style={{maxWidth:"100px"}} />
          <img src="assets/img/vendor-9.jpg" style={{maxWidth:"100px"}} />
        </div>
      </div>
    </div>
  </div>
  {/* Vendor End */}

</div>

    </div>
  )
}

export default Blog